/* nosaya-cart-fix.js — v7 PERFORMANCE */

/* ── BLOCK 1: Discount Persistence ── */
(function () {
  'use strict';

  function getCode() {
    var tag = document.querySelector('.discounts__discount-code, [data-discount-code]');
    if (tag) {
      var c = tag.dataset.discountCode || tag.textContent.trim();
      if (c) return c;
    }
    return new URLSearchParams(window.location.search).get('discount')
      || sessionStorage.getItem('nsy_discount_code')
      || null;
  }

  function applyCode(code) {
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
  }

  // Throttled observer — only fires max once per 500ms
  var discountTimer = null;
  new MutationObserver(function () {
    if (discountTimer) return;
    discountTimer = setTimeout(function () {
      discountTimer = null;
      var c = getCode();
      if (c) sessionStorage.setItem('nsy_discount_code', c);
    }, 500);
  }).observe(document.body, { childList: true, subtree: false }); // subtree:false = much cheaper

  document.addEventListener('DOMContentLoaded', function () {
    var c = sessionStorage.getItem('nsy_discount_code');
    if (c) applyCode(c);
  });
})();


/* ── BLOCK 2: Header Dropdown ── */
(function () {
  'use strict';

  function forceMenuStyle() {
    var h = document.querySelector('#header-component');
    if (!h) return;
    var ol = h.querySelector('overflow-list');
    if (window.innerWidth >= 750 && !(ol && ol.hasAttribute('minimum-reached'))) {
      h.dataset.menuStyle = 'menu';
    }
  }

  function injectDropdownStyles() {
    if (document.getElementById('nsy-dropdown-style')) return;
    var s = document.createElement('style');
    s.id = 'nsy-dropdown-style';
    s.textContent = '.nsy-dropdown{position:fixed!important;z-index:2147483647!important;width:auto!important;min-width:170px!important;max-width:240px!important;background:#080808!important;border:1px solid rgba(212,175,55,0.15)!important;border-top:2px solid #d4af37!important;box-shadow:0 16px 48px rgba(0,0,0,0.92),0 0 0 1px rgba(212,175,55,0.05)!important;padding:4px 0 8px!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;transition:opacity 0.2s ease,visibility 0.2s ease,transform 0.2s ease!important;transform:translateY(6px)!important;clip-path:none!important;overflow:hidden!important;border-radius:0 0 2px 2px!important;}.nsy-dropdown.nsy-open{visibility:visible!important;opacity:1!important;pointer-events:auto!important;transform:translateY(0)!important;}.nsy-dropdown .menu-list__submenu-inner{opacity:1!important;transform:none!important;padding:0!important;}.nsy-dropdown .mega-menu__link{display:block!important;padding:9px 18px!important;font-size:9px!important;font-weight:500!important;text-transform:uppercase!important;letter-spacing:2.8px!important;color:rgba(245,240,232,0.38)!important;text-decoration:none!important;transition:color 0.2s ease,padding-left 0.2s ease,background 0.2s ease,border-left-color 0.2s ease!important;white-space:nowrap!important;border-left:2px solid transparent!important;line-height:1.4!important;}.nsy-dropdown .mega-menu__link:hover{color:#d4af37!important;padding-left:24px!important;border-left-color:#d4af37!important;background:rgba(212,175,55,0.025)!important;}.nsy-dropdown .mega-menu__link--parent{display:block!important;padding:10px 18px 8px!important;font-size:7.5px!important;font-weight:700!important;letter-spacing:3.5px!important;color:rgba(212,175,55,0.5)!important;text-transform:uppercase!important;text-decoration:none!important;border-bottom:1px solid rgba(212,175,55,0.08)!important;margin-bottom:2px!important;border-left:none!important;cursor:default!important;pointer-events:none!important;}.nsy-dropdown .mega-menu__column+.mega-menu__column{border-top:1px solid rgba(212,175,55,0.06)!important;margin-top:2px!important;padding-top:2px!important;}';
    document.head.appendChild(s);
  }

  function teleportSubmenus() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll('#header-component .menu-list__submenu').forEach(function (sub) {
      if (sub._nsyTeleported) return;
      sub._nsyTeleported = true;
      var listItem = sub.parentElement;
      document.body.appendChild(sub);
      sub.classList.add('nsy-dropdown');
      sub.removeAttribute('style');

      function positionSub() {
        var hg = document.querySelector('.shopify-section-group-header-group');
        var top = hg ? hg.getBoundingClientRect().bottom : 72;
        var rect = listItem.getBoundingClientRect();
        sub.style.top = top + 'px';
        sub.style.left = rect.left + 'px';
      }
      function unlockInner() {
        sub.removeAttribute('inert');
        var inner = sub.querySelector('.menu-list__submenu-inner');
        if (inner) { inner.style.opacity = '1'; inner.style.transform = 'none'; }
      }
      var hideTimer = null;
      function showSub() { clearTimeout(hideTimer); positionSub(); unlockInner(); sub.classList.add('nsy-open'); }
      function scheduleHide() { hideTimer = setTimeout(function () { sub.classList.remove('nsy-open'); }, 120); }

      listItem.addEventListener('mouseenter', showSub);
      listItem.addEventListener('mouseleave', scheduleHide);
      sub.addEventListener('mouseenter', function () { clearTimeout(hideTimer); sub.classList.add('nsy-open'); });
      sub.addEventListener('mouseleave', scheduleHide);
      listItem.addEventListener('focusin', showSub);
      listItem.addEventListener('focusout', scheduleHide);
      sub.addEventListener('focusin', function () { clearTimeout(hideTimer); });
      sub.addEventListener('focusout', scheduleHide);
      window.addEventListener('scroll', positionSub, { passive: true });
      window.addEventListener('resize', positionSub, { passive: true });
    });
  }

  function init() {
    injectDropdownStyles();
    forceMenuStyle();
    teleportSubmenus();
    var header = document.querySelector('#header-component');
    if (!header) return;
    new MutationObserver(function () {
      if (window.innerWidth >= 750 && header.dataset.menuStyle === 'drawer') {
        var ol = header.querySelector('overflow-list');
        if (!(ol && ol.hasAttribute('minimum-reached'))) header.dataset.menuStyle = 'menu';
      }
    }).observe(header, { attributes: true }); // attributes only, no subtree
    window.addEventListener('resize', forceMenuStyle, { passive: true });
  }

// Delay full init until after page paint — removes from critical path
window.addEventListener('load', function () {
  setTimeout(init, 100);
}, { once: true });


})();


/* ── BLOCK 3: Cart — No Auto-Open + Real-Time Count ── */
(function () {
  'use strict';

  function updateBubble(count) {
    var n = count || 0;
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : (n > 0 ? String(n) : '');
    });
    document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(function (el) {
      if (n > 0) { el.classList.remove('visually-hidden'); el.hidden = false; }
      else { el.classList.add('visually-hidden'); }
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
    } catch (e) {}
  }

  function blockAutoOpen(e) {
    var comp = document.querySelector('cart-drawer-component');
    if (comp) comp.removeAttribute('auto-open');
    var originalPromise = e.promise;
    if (originalPromise && typeof originalPromise.then === 'function') {
      originalPromise.then(function (result) {
        var count = null;
        if (result && result.cart) {
          count = result.cart.totalQuantity !== undefined ? result.cart.totalQuantity : result.cart.item_count;
        } else if (result && result.detail && result.detail.cart) {
          count = result.detail.cart.totalQuantity || result.detail.cart.item_count;
        }
        if (count !== null) {
          updateBubble(count);
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) { updateBubble(c.item_count); })
            .catch(function () {});
        }
      }).catch(function () {});
    }
    try {
      Object.defineProperty(e, 'promise', { get: function () { return null; }, configurable: true });
    } catch (err) {
      try { e.promise = new Promise(function () {}); } catch (err2) {}
    }
  }

  document.addEventListener('cartLinesUpdate', blockAutoOpen, true);

  // Single lightweight observer for auto-open only
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'CART-DRAWER-COMPONENT' && node.hasAttribute('auto-open')) {
          node.removeAttribute('auto-open');
        }
      });
    });
  }).observe(document.body, { childList: true }); // childList only, no subtree, no attributes

  function refreshCartDrawer() {
    var drawerEl = document.querySelector('theme-drawer#cart-drawer');
    if (!drawerEl) return;
    var cartComp = drawerEl.querySelector('cart-items-component');
    var sid = cartComp ? cartComp.dataset.sectionId : 'cart-drawer-section';
    fetch('/?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sid];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var freshComp = tmp.querySelector('cart-items-component');
        if (freshComp && cartComp && cartComp.innerHTML !== freshComp.innerHTML) {
          cartComp.innerHTML = freshComp.innerHTML;
          if (typeof cartComp.updatedCallback === 'function') cartComp.updatedCallback();
        }
        var freshInner = tmp.querySelector('.cart-drawer__inner');
        var liveInner = drawerEl.querySelector('.cart-drawer__inner');
        if (freshInner && liveInner) {
          if (freshInner.classList.contains('cart-drawer--empty')) {
            liveInner.classList.add('cart-drawer--empty');
          } else {
            liveInner.classList.remove('cart-drawer--empty');
          }
        }
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('cart-icon button, [aria-controls="cart-drawer"], [data-action="open-cart"], a[href="/cart"]');
    if (!btn) return;
    if (btn.tagName === 'A' && btn.href && btn.href.indexOf('/cart') !== -1 && !btn.closest('theme-drawer')) return;
    refreshCartDrawer();
  }, true);

  document.addEventListener('theme-drawer:open', function (e) {
    if (e.target && e.target.id === 'cart-drawer') refreshCartDrawer();
  }, true);

  function syncCountBubble() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateBubble(c.item_count || 0); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(syncCountBubble, 150); });
  } else {
    setTimeout(syncCountBubble, 150);
  }
})();
